import React from 'react';
import { Table, TableHead, TableBody, TableFooter, withStyles } from "@material-ui/core";

const styles = theme => ({

});

const SimpleTable = (props) => {
    const { head, body, footer,  tableHeadProps, tableBodyProps, tableFooterProps, tableProps } = props;

    const tableHead = head ? <TableHead {...tableHeadProps}>{head}</TableHead> : ''
    const tableBody = body ? <TableBody {...tableBodyProps}>{body}</TableBody> : ''
    const tableFooter = footer ? <TableFooter {...tableFooterProps}>{footer}</TableFooter> : ''

    return (
        <Table {...tableProps}>
            {tableHead}
            {tableBody}
            {tableFooter}
        </Table>
    )
}

export default withStyles(styles)(SimpleTable);